import { legacy_createStore as createStore, applyMiddleware } from 'redux';
import { thunk } from 'redux-thunk';
import rootReducer from './reducer';

const composedEnhancer = applyMiddleware(thunk);

const store = createStore(rootReducer, undefined, composedEnhancer);
export default store;
